/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetWorkloadCustomFlowsSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type GetWorkloadCustomFlowsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetWorkloadCustomFlowsSecurity = {
  option1?: GetWorkloadCustomFlowsSecurityOption1 | undefined;
  option2?: GetWorkloadCustomFlowsSecurityOption2 | undefined;
};

export type GetWorkloadCustomFlowsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetWorkloadCustomFlowsSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetWorkloadCustomFlowsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetWorkloadCustomFlowsSecurityOption1$Outbound,
    GetWorkloadCustomFlowsSecurityOption1
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getWorkloadCustomFlowsSecurityOption1ToJSON(
  getWorkloadCustomFlowsSecurityOption1: GetWorkloadCustomFlowsSecurityOption1,
): string {
  return JSON.stringify(
    GetWorkloadCustomFlowsSecurityOption1$outboundSchema.parse(
      getWorkloadCustomFlowsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetWorkloadCustomFlowsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetWorkloadCustomFlowsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetWorkloadCustomFlowsSecurityOption2$Outbound,
    GetWorkloadCustomFlowsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getWorkloadCustomFlowsSecurityOption2ToJSON(
  getWorkloadCustomFlowsSecurityOption2: GetWorkloadCustomFlowsSecurityOption2,
): string {
  return JSON.stringify(
    GetWorkloadCustomFlowsSecurityOption2$outboundSchema.parse(
      getWorkloadCustomFlowsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetWorkloadCustomFlowsSecurity$Outbound = {
  Option1?: GetWorkloadCustomFlowsSecurityOption1$Outbound | undefined;
  Option2?: GetWorkloadCustomFlowsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetWorkloadCustomFlowsSecurity$outboundSchema: z.ZodMiniType<
  GetWorkloadCustomFlowsSecurity$Outbound,
  GetWorkloadCustomFlowsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetWorkloadCustomFlowsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetWorkloadCustomFlowsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getWorkloadCustomFlowsSecurityToJSON(
  getWorkloadCustomFlowsSecurity: GetWorkloadCustomFlowsSecurity,
): string {
  return JSON.stringify(
    GetWorkloadCustomFlowsSecurity$outboundSchema.parse(
      getWorkloadCustomFlowsSecurity,
    ),
  );
}

/** @internal */
export type GetWorkloadCustomFlowsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetWorkloadCustomFlowsRequest$outboundSchema: z.ZodMiniType<
  GetWorkloadCustomFlowsRequest$Outbound,
  GetWorkloadCustomFlowsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getWorkloadCustomFlowsRequestToJSON(
  getWorkloadCustomFlowsRequest: GetWorkloadCustomFlowsRequest,
): string {
  return JSON.stringify(
    GetWorkloadCustomFlowsRequest$outboundSchema.parse(
      getWorkloadCustomFlowsRequest,
    ),
  );
}
